export const PAGE_ANIMATION_OPTIONS = {
                                            pageInitial: {
                                                            opacity: 0
                                                        },
                                            pageAnimate: {
                                                            opacity: 1
                                                        }
                                        }